"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useFonts = (fontUrls) => {
    (0, react_1.useEffect)(() => {
        // Import fonts by creating link elements
        fontUrls.forEach((url) => {
            const link = document.createElement("link");
            link.href = url;
            link.rel = "stylesheet";
            document.head.appendChild(link);
        });
    }, [fontUrls]);
};
exports.default = useFonts;
